import { defineMessages } from 'react-intl';

import { shared } from 'lang/shared.text';

export const texts = defineMessages({
  ...shared.region,
  heading: {
    id: 'EditLocationModal.heading',
    description: 'Heading',
    defaultMessage: 'Redigera arbetsplats',
  },
  button: {
    id: 'EditLocationModal.button',
    description: 'Button',
    defaultMessage: 'Spara',
  },
  trigger: {
    id: 'EditLocationModal.trigger',
    description: 'Trigger',
    defaultMessage: 'Redigera',
  },
  editCompanyLocationSuccess: {
    id: 'EditLocationModal.editCompanyLocationSuccess',
    description: 'Edit company location success',
    defaultMessage: 'Arbetsplatsen är uppdaterad',
  },
});
